// @ts-nocheck
import { createContext, useContext } from 'react';

export const UserContext = createContext();

export const useUserContext: any = () => useContext(UserContext);
